import React, { useState } from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { formatNewMoney } from 'src/utils/formatter';
import './FactoringNotice.css';

// Las fechas de cesión se guardan con la hora del SII como UTC: se muestran en UTC para no correrlas.
const formatCesionDate = (value) => (value ? moment.utc(value).format('DD/MM/YYYY HH:mm') : '');

/**
 * Aviso de documento cedido. `issuerName`/`cesionDate` son el cesionario vigente (la última cesión);
 * `cesiones` es el historial del registro del SII: una factura puede cederse varias veces (recesión).
 */
const FactoringNotice = ({ issuerName, cesionDate, downloadUrl, cesiones = [] }) => {
  const { t } = useTranslation('documents');
  const [open, setOpen] = useState(false);
  const history = Array.isArray(cesiones) ? cesiones : [];

  return (
    <div className="factoring-notice">
      <div className="factoring-notice__icon">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
      <div className="factoring-notice__content">
        <div className="factoring-notice__text">
          {t('factoringNotice.ceded')}
          {issuerName && ` ${t('factoringNotice.to')} `}<strong>{issuerName}</strong>
          {cesionDate && ` ${t('factoringNotice.on', { date: cesionDate })}`}
          {history.length > 1 && <span className="factoring-notice__count"> · {t('factoringNotice.count', { count: history.length })}</span>}
        </div>
        <div className="factoring-notice__links">
          {history.length > 1 && (
            <button type="button" className="factoring-notice__link-text" onClick={() => setOpen((value) => !value)}>
              {t(open ? 'factoringNotice.hideHistory' : 'factoringNotice.showHistory')}
            </button>
          )}
          {downloadUrl && (
            <a href={downloadUrl} target="_blank" rel="noopener noreferrer" className="factoring-notice__link-text">
              {t('factoringNotice.certificate')}
            </a>
          )}
        </div>
        {open && history.length > 1 && (
          <ol className="factoring-notice__history">
            {history.map((cesion, index) => (
              <li key={`${cesion.date}-${index}`} className={index === history.length - 1 ? 'is-current' : ''}>
                <span className="factoring-notice__history-date">{formatCesionDate(cesion.date)}</span>
                <span>
                  {cesion.cedenteName || cesion.cedenteId} → <strong>{cesion.cesionarioName || cesion.cesionarioId}</strong>
                </span>
                {cesion.amount != null && <span className="factoring-notice__history-amount">${formatNewMoney(cesion.amount)}</span>}
              </li>
            ))}
          </ol>
        )}
      </div>
    </div>
  );
};

export default FactoringNotice;
